// extracted by css-extract-rspack-plugin
export default {"root":"bX5OJQ","text-block":"lSnXwA","textBlock":"lSnXwA","prefix":"wo3Wam"};